import React, {useState} from 'react';
import styled from 'styled-components'

export default function PriceShow({onBuyMasterclass, isRegistered, isSubscribed, courseId, wherebyUrl, isDone, hasVideo, startsAt, classDurationMinutes}) {
    const [isProccesing, setIsProcessing] = useState(false)
    const subscriptionUrl = '/buy/page?cid=' + courseId
    let goToOnlineClassRoom = false

    const startDate = startsAt.split(' ')
    const dateArray = startDate[0].split('/')
    const today = new Date();
    const classStartDate = new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]}T${startDate[1]}:00`);
    const endAt = new Date(`${dateArray[2]}-${dateArray[1]}-${dateArray[0]}T${startDate[1]}:00`)
    endAt.setMinutes(endAt.getMinutes() + classDurationMinutes)
    today.setMinutes(today.getMinutes() + 15); // minutes before when link will be available
    goToOnlineClassRoom = today.getTime() >= classStartDate.getTime() && today.getTime() <= endAt.getTime()
    const pastDate = new Date() > endAt.getTime()

    if(isDone || pastDate) {
        return (
            <Container>
                <Accesscontainer>{hasVideo ? '¡La clase ha pasado! pero don’t worry, aquí tienes el vídeo ': 'La clase ha pasado '}</Accesscontainer>
                {!isRegistered && hasVideo && (
                    <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'center' }}>
                        <div className={'button col-1 col-offset-5'} onClick={onBuyMasterclass}>Comprar</div>
                    </div>
                )}


            </Container>
        )
    }

    if(isProccesing) return (<Container> <Accesscontainer>procesando</Accesscontainer></Container>)
    return (
        <Container>
            {(<PriceContainer>Comienza el: { startsAt }</PriceContainer>)}
            {isRegistered && goToOnlineClassRoom && (
                <RegisteredContainer>
                    <Accesscontainer>Aqui tienes tu acceso</Accesscontainer>
                    <BotonContainer>
                        <BotonBuy target='_blank' href={wherebyUrl}><IconBuy src="/images/icon_blackboard.svg"/> Acceder al aula online</BotonBuy>
                    </BotonContainer>
                </RegisteredContainer>)
            }
            {!isRegistered && !pastDate && (<BotonContainer><BotonBuy href={subscriptionUrl}>Suscribirme</BotonBuy></BotonContainer>)}
            {!isRegistered && !pastDate && !isSubscribed ? (<SubscriptionClaim>Únete para acceder a las private class</SubscriptionClaim>) : null}
        </Container>
    )
}

const IconBuy = styled.img`
    height: 18px;
    margin-right: 8px;
`

const SubscriptionClaim = styled.div`
    text-align: center;
    font-size: 14px;
    padding-top: 24px;

`

const BotonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content:center;
    padding-top: 12px;
`

const Accesscontainer = styled.div`
    text-align: center;
    font-size: 18px;
    color: white;
    font-weight: bold;
`

const BotonBuy = styled.a`
    border: 1px solid #FA9F63;
    color: #FA9F63;
    padding: 12px 24px;
    margin-top: 12px;
    border-radius: 4px;

    &:hover {
    border: 1px solid white;
        color: white;
    }
`

const PriceFree = styled.div`
    text-align: center;
    font-size: 18px;
    color: white;
    font-weight: bold;
`

const PriceContainer = styled.div`
  text-align: center;
    font-size: 24px;
    color: white;
    font-weight: bold;
    margin-bottom: 15px;
`
const RegisteredContainer = styled.div`
  text-align: center;
    font-size: 18px;
    color: white;
    font-weight: bold;
`

const Container = styled.div`
    margin-top: 48px;
    background-color: #0B0E10;
    padding: 26px 24px;
    border-radius: 4px;
    border: 1px solid white;
`
const CenteredMessage = styled.div`
    text-align: center;
`
